import React from 'react';
import * as styles from './index.module.less';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { CLASS_MAP } from '@/modules/pricing-v2/pricing-card-container';
import { LanguageType } from '@/modules/pricing-v2/type';

interface IProps {
  link: string;
  className?: string;
  btnClass?: string;
  type?: GOODS_TYPE;
  lang?: LanguageType;
  children?: any;
}

const PricingBtn = ({ link, className, btnClass, type, lang = 'ja', children }: IProps) => {
  return (
    <a href={link} className={`${className} ${styles.link_wrapper}`}>
      <button className={`${btnClass} ${styles[CLASS_MAP[type]]} ${styles[lang]}`}>{children}</button>
    </a>
  );
};
export default PricingBtn;
